import { getAnalytics } from './global'

// eslint-disable-next-line @typescript-eslint/no-var-requires
const analyticsDefaultEvents = require('../../../scripts/custom/components/analytics/analytics-events.json')
const discriminatorPlaceholder = '{{discriminator}}'

interface AnalyticsEvent {
  readonly eventCategory: string
  readonly eventAction: string
  readonly eventLabel?: string | undefined
  readonly eventValue?: number | undefined
  readonly nonInteraction?: boolean | undefined
}

interface DefaultAnalyticsEvent {
  readonly category: string
  readonly action: string
}

export function sendEvent(event: AnalyticsEvent) {
  const analytics = getAnalytics()
  // There is no guaruntee that analytics will be available
  // There is a possibility that ga won’t be defined because customers can define their own head.js
  if (analytics) {
    analytics('send', 'event', event)
  }
}

export function sendDefaultEvent(
  eventKey: string,
  eventDiscriminator?: string
) {
  const event = getDefaultEvent(eventKey, eventDiscriminator)
  if (event) {
    sendEvent(event)
  } else {
    // eslint-disable-next-line no-console
    console.warn('error sending default GA event, default event was not found')
  }
}

/* based on cs-analytics-events.service.js */
export function getDefaultEvent(
  eventKey: string,
  eventDiscriminator?: string
): AnalyticsEvent | undefined {
  const defaultEvent: DefaultAnalyticsEvent = analyticsDefaultEvents[eventKey]

  return defaultEvent
    ? {
        eventCategory: defaultEvent.category,
        eventAction: !!eventDiscriminator
          ? defaultEvent.action.replace(
              discriminatorPlaceholder,
              eventDiscriminator
            )
          : defaultEvent.action
      }
    : undefined
}
